module.exports = __webpack_public_path__ + "static/media/service2.c4ac62f1.jpg";